import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const SrBatteryMessage = ({ message, tooltipCopy, isNegative, flipTooltip, small }) => {
  return (
    <div
      className={classNames('SrBatteryMessage', {
        positive: !isNegative,
        negative: isNegative,
        small: small,
      })}
    >
      <div className="icon" />
      <span className="message">
        {message}
        {tooltipCopy && (
          <span
            className={classNames('sr-tooltip info', {
              flipTooltip: flipTooltip,
            })}
          >
            <span className="icon question" />
            <span className="text question">{tooltipCopy}</span>
          </span>
        )}
      </span>
    </div>
  );
};

SrBatteryMessage.propTypes = {
  message: PropTypes.string.isRequired,
  tooltipCopy: PropTypes.string,
  isNegative: PropTypes.bool.isRequired,
  flipTooltip: PropTypes.bool,
  small: PropTypes.bool,
};

SrBatteryMessage.displayName = 'SrBatteryMessage';

export default SrBatteryMessage;
